var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChartActive = function SvgChartActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#26BAB9",
    d: "M20.084 20.854h-16.5a.693.693 0 0 1-.688-.687c0-.376.312-.688.688-.688h16.5c.375 0 .687.312.687.688a.693.693 0 0 1-.687.687M5.967 7.682H4.5a.92.92 0 0 0-.917.916V16.5a.92.92 0 0 0 .917.917h1.467a.92.92 0 0 0 .917-.917V8.598a.913.913 0 0 0-.917-.916M12.567 4.757H11.1a.92.92 0 0 0-.916.917V16.5a.92.92 0 0 0 .916.916h1.467a.92.92 0 0 0 .917-.916V5.674a.92.92 0 0 0-.917-.917M19.167 1.834H17.7a.92.92 0 0 0-.916.916V16.5a.92.92 0 0 0 .916.917h1.467a.92.92 0 0 0 .917-.917V2.75a.92.92 0 0 0-.917-.917"
  })));
};
export default SvgChartActive;